import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import Newsletters from 'services/Newsletters/';
import { Link } from 'react-router-dom';
import InputEmail from 'components/InputEmail';
import TagManagerService from 'services/TagManager';
import { cleanSearch } from 'utils/index';
import Loader from 'components/Loader';
import Rut from 'components/Forms/Inputs/InputRut';
import style from './style.scss';//NOSONAR

const NewsletterContent = ({ closeNewsletter }) => {
    const [formIsValid, setFormIsValid] = useState(false);
    const [rutIsValid, setRutIsValid] = useState(false);
    const [emailIsValid, setEmailValid] = useState(false);
    const [rutValue, setRutValue] = useState('');
    const [isLoading, setLoading] = useState(false);

    const emailInput = useRef(null);
    const checkbox = useRef(null);

    const submitSuscribe = () => {
        let email = emailInput.current.value;
        let rut = cleanSearch(rutValue.replace( /\s/g, ''));
        
        setLoading(true);

        Newsletters.suscribeNewsletter(email, rut).then(response => {
            setLoading(false);
            closeNewsletter();
            return response
        });

        TagManagerService.suscribe('Envío solicitud', email);
    }

    const validateForm = () => {
        const isvalid =  rutIsValid && emailIsValid && checkbox.current.checked;
        if (isvalid !== formIsValid) {
            setFormIsValid(isvalid);
        }
    }

    const _getValidMail = (isValid) => {
        setEmailValid(isValid);
    }

    const rutValid = (valid, value) => {
        setRutIsValid(valid);
        setRutValue(value);
    }

    return (
        <div className="new-modal-container modal-newsletter-content">
            {isLoading && <div className="footer-newsletter-loader"><Loader/></div>}
            <div className={'new-modal-scroll'}>
                <h3 className="new-modal-title">Suscríbete</h3>
                <span className="newsletter-subtitle">¡Y no te pierdas ninguna oferta de Jumbo.cl!</span>
                <form className="input-wrapper-validation">
                    <div className="newsletter-container-form-mail">
                        <InputEmail
                            ref={emailInput}
                            showIcon={true}
                            key="Email"
                            className={'footer-newsletter-form-mail'}
                            name="Email"
                            label="Mail"
                            required={true}
                            placeholder="Mail"
                            value={''}
                            type="email"
                            helpText=""
                            size=""
                            message={{ error: "Mail inválido" }}
                            validateForm={validateForm}
                            aria-label="Mail input"
                            callbackValidate={_getValidMail}
                        />
                    </div>
                    <div className={'newsletter-container-form-rut' + ((!rutIsValid) ? ' container-error' : '')}>
                        <label className="newsletter-input-rut-title required" htmlFor="rut">RUT</label>
                        <Rut callbackisValid={rutValid} errorMessageValue={'Rut inválido'}/>
                    </div>
                </form>
                <div className="newsletter-container-form-label">
                    <label className="newsletter-form-label">
                        <input className="newsletter-input-check mobile-click" type="checkbox" name='Terms Acceptation' ref={checkbox} onChange={validateForm} />
                        <span className="newsletter-terms-and-conditions">Acepto los <Link to="/institucional/terminos-condiciones" className="newsletter-link">Términos y Condiciones</Link></span>
                    </label>
                </div>
            </div>
            

            <div className="modal-actions">
                <button type="button" className="secundary-btn" onClick={closeNewsletter}>
                    <span>Volver</span>
                </button>
                <button type="submit" className={'footer-newsletter-form-submit ' + (formIsValid ? ' primary-btn ' : ' disabled-btn ')} onClick={submitSuscribe}>
                    <span className="modal-validation-code-change-pasword">Confirmar</span>
                </button>
            </div>
        </div>
    )
}

NewsletterContent.propTypes = {
    closeNewsletter: PropTypes.func
}

export default NewsletterContent;